<template>
  <!-- you can rename class or id for this component, please put your comment what you need for styling needs -->

  <div :class="nameclass || 'CountryDefaultClass'">
    <!-- for each component have default label and classname, 
    you can inherit when you call the component-->
    <label for="component-dropdown">{{ label || "Country choice" }}</label>
    <b-form-select
      @input="(event) => {
          $emit('update', event);}"
      v-model="selected"
      :options="country"
      value-field="id"
      text-field="country_long_name"
      size="lg"
      :style="{backgroundColor:value ? 'rgba(79, 208, 110,0.2)':'aliceblue'}"
    >
      <template v-slot:first>
        <b-form-select-option value="null" disabled>-- Please select an option --</b-form-select-option>
      </template>
    </b-form-select>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  inheritAttrs: false,
  props: ["value", "nameclass", "label"],
  model: {
    prop: "value",
    event: "update"
  },
  data() {
    return {
      selected: this.value
    };
  },
  mounted() {},
  computed: mapState(["country"]),
  async created() {
    await this.$store.dispatch("loadCountry");
    this.selected = 234;
  },
  watch: {
    value: function(updated, old) {
      if (updated) {
        this.selected = updated;
      }
    }
  }
};
</script>
